export default __webpack_public_path__ + "static/media/webpack.b460dec8.svg";